export default __webpack_public_path__ + "static/media/playstore.673427c7.png";